/**
 * API definition for Common AiStudio Interfaces
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.7
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type ProjectType = 'IMAGE_CLASSIFICATION_SINGLE_LABEL' | 'OBJECT_DETECTION' | 'PHOTOGRAMMETRY' | 'ROOM_SCAN' | 'SCENE_RECONSTRUCTION';

export const ProjectType = {
    ImageClassificationSingleLabel: 'IMAGE_CLASSIFICATION_SINGLE_LABEL' as ProjectType,
    ObjectDetection: 'OBJECT_DETECTION' as ProjectType,
    Photogrammetry: 'PHOTOGRAMMETRY' as ProjectType,
    RoomScan: 'ROOM_SCAN' as ProjectType,
    SceneReconstruction: 'SCENE_RECONSTRUCTION' as ProjectType
};

